import React from 'react';
import { connect } from 'react-redux';

import {
  getAllDocumentTemplates,
  getDocumentTemplateStats,
} from 'actions/landlordDocumentTemplatesActions';

import styled from 'styled-components';
import { Formik, Form } from 'formik';

import { H2, ButtonPrimary, InputFile } from '@yuhu-inc/yuhui';
import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';
import { documentTemplateAcceptedFileTypes } from 'helpers/FileHelper';
import MediaQuery from 'react-responsive';

import { StyledFooterText } from './form_fields/shared_styles/footers';

const StyledForm = styled(Form)`
  width: 50%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${media.mobile`
  width: 80%;
  `};
`;

const StyledInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 5rem;
  margin-bottom: 5rem;
  max-height: 570px;
  max-width: 570px;
`;

const StyledInputFile = styled(InputFile)`
  overflow-y: auto;
  white-space: nowrap;
  padding-right: 30px;
`;

const StyledError = styled.div`
  margin: 0px 10px;
  color: red;
`;

const StyledButton = styled(ButtonPrimary)`
  margin-top: 25px;
  width: fit-content;
  align-self: center;
`;

const StyledLabel = styled.p`
  font-size: 18px;
  font-weight: bold !important;
  margin: 10px 10px 0px;
`;

export const DocumentTemplateUploadFilePage = connect(null, {
  getAllDocumentTemplates,
  getDocumentTemplateStats,
})(({ setTemplate, forward, documentTemplate = {}, uploadedFiles = [], isEdit, ...rest }) => {
  const inputFileValid = (values) => {
    return (
      values.files.length > 0 || (isEdit && values.uploadedFiles.some((file) => file.keep === true))
    );
  };

  return (
    <Formik
      initialValues={{
        files: [],
        uploadedFiles: uploadedFiles,
      }}
      onSubmit={(values) => {
        if (!inputFileValid(values)) {
          return;
        }

        setTemplate((template) => {
          template.file = values.files;
          if (isEdit) {
            template.uploadedFiles = values.uploadedFiles;
          }
          return { ...template };
        });
        forward();
      }}
    >
      {({ values, setFieldValue, errors, touched }) => (
        <StyledForm {...rest}>
          <StyledInner>
            <H2 contentKey="landlordPortal.documentTemplate.uplodateFiles" centered />
            <StyledLabel>
              {getTranslatedString('landlordPortal.documentTemplate.uploadFile.files')}
            </StyledLabel>
            <MediaQuery query="(max-device-width: 750px)">
              <StyledInputFile
                newFiles={values.files}
                data={isEdit && values.uploadedFiles}
                onChange={(newValues, uploadedValues) => {
                  setFieldValue('files', newValues);
                  if (isEdit) {
                    setFieldValue('uploadedFiles', uploadedValues);
                  }
                }}
                onDropVerbiage={getTranslatedString(
                  'landlordPortal.documentTemplate.uploadFile.dropFileMobileVerbiage'
                )}
                dropFileVerbiage={getTranslatedString(
                  'landlordPortal.documentTemplate.uploadFile.dropFileMobileVerbiage'
                )}
                rejectFileError={getTranslatedString(
                  'landlordPortal.documentTemplate.uploadFile.cannotAcceptFile'
                )}
                acceptedFiles={documentTemplateAcceptedFileTypes}
              />
            </MediaQuery>
            <MediaQuery query="(min-device-width: 751px)">
              <StyledInputFile
                newFiles={values.files}
                data={isEdit && values.uploadedFiles}
                onChange={(newValues, uploadedValues) => {
                  setFieldValue('files', newValues);
                  if (isEdit) {
                    setFieldValue('uploadedFiles', uploadedValues);
                  }
                }}
                onDropVerbiage={getTranslatedString(
                  'landlordPortal.documentTemplateDetailsForm.dropFileHere'
                )}
                dropFileVerbiage={getTranslatedString(
                  'landlordPortal.documentTemplateDetailsForm.dragAndDrop'
                )}
                browseVerbiage={getTranslatedString(
                  'landlordPortal.documentTemplateDetailsForm.orBrowse'
                )}
                rejectFileError={getTranslatedString(
                  'landlordPortal.documentTemplate.uploadFile.cannotAcceptFile'
                )}
                acceptedFiles={documentTemplateAcceptedFileTypes}
              />
            </MediaQuery>
            {!inputFileValid(values) && (
              <StyledError>
                {getTranslatedString(
                  'landlordPortal.documentTemplate.uploadFile.uploadAtLeastOneFile'
                )}
              </StyledError>
            )}

            <StyledButton contentKey="landlordPortal.inspections.next" />
            <StyledFooterText>
              {getTranslatedString('landlordPortal.documentTemplate.completedPagesAutoSave')}
            </StyledFooterText>
          </StyledInner>
        </StyledForm>
      )}
    </Formik>
  );
});
